/**
 * Helper function for translating error messages if possible.
 * @returns translated translationKey if translationKey provided, otherwise returns message
 */
export function translateErrorMessageIfPossible({
  translationKey,
  translationValues,
  t,
  message,
}: {
  translationKey?: string;
  translationValues?: Record<string, unknown>;
  t: (key: string, values: unknown) => string;
  message: string;
}) {
  if (translationKey) {
    return t(translationKey, translationValues);
  }
  return message;
}
